import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import BASE_URL, { IMAGE_DOMAIN } from '../../../config/config';
import Loader from '../../../components/Loader';

const GestorUsuarios = () => {
  const [cargando, setCargando] = useState(true);
  const [usuarios, setUsuarios] = useState([]);
  const [usuariosFiltrados, setUsuariosFiltrados] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [rolSeleccionado, setRolSeleccionado] = useState('');
  const [paginaActual, setPaginaActual] = useState(1);
  const usuariosPorPagina = 12;

  const token = localStorage.getItem('AuthToken');
  const navigate = useNavigate();

  useEffect(() => {
    const obtenerUsuarios = async () => {
      try {
        const peticionUsuarios = axios.get(`${BASE_URL}/todos-usuarios`, {
          headers: { Authorization: token }
        });
        const esperaMinima = new Promise(resolve => setTimeout(resolve, 1000));
        const [response] = await Promise.all([peticionUsuarios, esperaMinima]);

        if (Array.isArray(response.data.usuarios)) {
          const ordenados = response.data.usuarios.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setUsuarios(ordenados);
          setUsuariosFiltrados(ordenados);
        } else {
          setUsuarios([]);
          setUsuariosFiltrados([]);
        }
      } catch (error) {
        console.error('Error al obtener usuarios:', error);
      } finally {
        setCargando(false);
      }
    };

    obtenerUsuarios();
  }, [token]);

  useEffect(() => {
    const filtrados = usuarios.filter(user =>
      (user.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
        user.apellidos?.toLowerCase().includes(busqueda.toLowerCase()) ||
        user.usuario?.toLowerCase().includes(busqueda.toLowerCase())) &&
      (rolSeleccionado === '' || user.role === rolSeleccionado)
    );
    setUsuariosFiltrados(filtrados);
    setPaginaActual(1);
  }, [busqueda, rolSeleccionado, usuarios]);

  const totalPaginas = Math.ceil(usuariosFiltrados.length / usuariosPorPagina);
  const indiceUltimo = paginaActual * usuariosPorPagina;
  const indicePrimero = indiceUltimo - usuariosPorPagina;
  const usuariosActuales = usuariosFiltrados.slice(indicePrimero, indiceUltimo);

  const cambiarPagina = (numeroPagina) => {
    if (numeroPagina >= 1 && numeroPagina <= totalPaginas) {
      setPaginaActual(numeroPagina);
    }
  };

  const irADetalle = (usuario) => {
    try {
      navigate(`/dashboard/users/${usuario}`);
    } catch (error) {
      console.error('Error al navegar:', error);
    }
  };

  if (cargando) {
    return <Loader />;
  }

  return (
    <main className="site-width">
      <div className="contenedor-gestor-usuarios">
        <h2 className="titulo-seccion">Gestión de usuarios</h2>
        <p>Administra los ajustes, estados y servicios de los usuarios.</p>

        <div className="filtros-usuarios">
          <input
            type="text"
            placeholder="Buscar por nombre, apellidos o usuario"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            className="campo-busqueda"
          />

          <select
            value={rolSeleccionado}
            onChange={(e) => setRolSeleccionado(e.target.value)}
            className="selector-rol"
          >
            <option value="">Todos los roles</option>
            <option value="user">Usuario</option>
            <option value="admin">Administrador</option>
          </select>
        </div>

        <div className="lista-usuarios">
          {usuariosActuales.length > 0 ? (
            usuariosActuales.map(user => (
              <div
                key={user.usuario}
                className="tarjeta-usuario"
                style={user.estado === 'verificar' ? { backgroundColor: '#fffcca' } : {}}
                onClick={() => irADetalle(user.usuario)}
              >
                {/* ------------------------------------ */}

                <div className="imagen-usuario">
                  <img src={user.fotoPerfil ? (user.fotoPerfil.startsWith('http') ? user.fotoPerfil : `${IMAGE_DOMAIN}${user.fotoPerfil}`) : `${IMAGE_DOMAIN}/images/default-user.png`} alt="Foto de perfil" />
                </div>
                <div className="info-usuario">
                  <h3>{user.nombre} {user.apellidos}</h3>
                  <p className="nombre-usuario">@{user.usuario}</p>
                  <div className="datos-usuario">
                    {user.estado === 'verificar' && (
                      <p
                        className="pendiente-verificar"
                      >
                        Requiere atención
                      </p>
                    )}
                    <p className={`${user.role === 'admin' ? 'rol-admin' : 'rol-user'}`}>
                      {user.role === 'admin' ? 'Administrador' : 'Usuario'}
                    </p>
                    <p className="fecha-union">
                      <span>Se unió el </span>
                      {new Date(user.createdAt).toLocaleString('es-ES', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </p>
                  </div>
                </div>
                <div className="acciones-usuario">
                  <button>Gestionar perfil</button>
                </div>
              </div>
            ))
          ) : (
            <p className="mensaje-no-usuarios">No se encontraron usuarios.</p>
          )}
        </div>

        <div className="paginacion-usuarios">
          <button className='anterior' onClick={() => cambiarPagina(paginaActual - 1)} disabled={paginaActual === 1}>
            Anterior
          </button>
          <span>Página {paginaActual} de {totalPaginas}</span>
          <button className='siguiente' onClick={() => cambiarPagina(paginaActual + 1)} disabled={paginaActual === totalPaginas}>
            Siguiente
          </button>
        </div>
      </div>
    </main>
  );
};

export default GestorUsuarios;
